import auth from './auth.json';
import supabase from './supabase.json';

export default {
  supabase,
  auth,
};
